import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component( {
  selector: 'dynamica-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe
  ],
} )
export class PageNotFoundComponent {
  isLoggedIn = false;

  constructor(
    public authService: AuthService,
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
  ) {
    this.oidcSecurityService.isAuthenticated$.subscribe( ( { isAuthenticated } ) => {
        this.isLoggedIn = isAuthenticated;
      }
    );
  }

  goBack(): void {
    this.router.navigate( ['/pages/booking-overview'] );
  }

  gotoLogin(): void {
    this.authService.logout();
  }
}
